var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9538 8.09797C25.4006 7.54485 24.5071 7.54485 23.954 8.09797L17.0188 15.019L10.0835 8.08378C9.5304 7.53067 8.6369 7.53067 8.08378 8.08378C7.53067 8.6369 7.53067 9.5304 8.08378 10.0835L15.019 17.0188L8.08378 23.954C7.53067 24.5071 7.53067 25.4006 8.08378 25.9538C8.6369 26.5069 9.5304 26.5069 10.0835 25.9538L17.0188 19.0185L23.954 25.9538C24.5071 26.5069 25.4006 26.5069 25.9538 25.9538C26.5069 25.4006 26.5069 24.5071 25.9538 23.954L19.0185 17.0188L25.9538 10.0835C26.4927 9.54458 26.4927 8.6369 25.9538 8.09797Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupClose);
export default __webpack_public_path__ + "static/media/Popup-Close.fbfa6831e83a010ad700d0b679488cfc.svg";
export { ForwardRef as ReactComponent };